export default [{
        path: "/nutritionDeliveryRatio",
        name: "supplyProportion",
        component: () =>
            import ("@/components/page/Nutrition/baseData/supplyProportion"),
        meta: { title: "供货比重" },
    },
    {
        path: "/bbb",
        name: "cookMethodConfig",
        component: () =>
            import ("@/components/page/Nutrition/baseData/cookMethodConfig"),
        meta: { title: "烹饪方式配置" },
    },
    {
        path: "/nutritionInspectTemplate",
        name: "dqmpDetail",
        component: () =>
            import ("@/components/page/Nutrition/baseData/detectionTemplateConfig"),
        meta: { title: "检测模板配置" },
    },
    {
        path: "/nutritionInspectWindow",
        name: "detectionWindowPeriod",
        component: () =>
            import ("@/components/page/Nutrition/baseData/detectionWindowPeriod"),
        meta: { title: "检测窗口期配置" },
    },
    {
        path: "/dataDictionaryConfig",
        name: "dataConfig",
        component: () =>
            import ("@/components/page/Nutrition/baseData/dataConfig"),
        meta: { title: "数据字典配置" },
    },
    {
        path: "/nutritionReport",
        name: "griNutritionAnalysis",
        component: () =>
            import ("@/components/page/Nutrition/manage/griNutritionAnalysis"),
        meta: { title: "GRI Nutrition Analysis" },
    },
    {
        path: "/nutritionIngredient",
        name: "ingredient",
        component: () =>
            import ("@/components/page/Nutrition/manage/ingredient"),
        meta: { title: "Ingredient主数据" },
    },
    {
        path: "/nutritionInspect",
        name: "nutritionDetection",
        component: () =>
            import ("@/components/page/Nutrition/manage/nutritionDetection"),
        meta: { title: "Nutrition检测" },
    },
    {
        path: "/nutritionInspect/detail",
        name: "nutritionDetail",
        component: () =>
            import ("@/components/page/Nutrition/manage/nutritionDetail"),
        meta: { title: "Nutrition检测详情" },
    },
    {
        path: "/nutritionReport/detail",
        name: "nutritionAnalysisDetail",
        component: () =>
            import ("@/components/page/Nutrition/manage/griNutritionAnalysisDetail"),
        meta: { title: "GRI Nutrition Analysis详情" },
    },
];